export default __webpack_public_path__ + "static/media/all-akun.b4cf906b.png";